import { ContactUs } from 'components/gruenland/pages/contact-us/ContactUs';
import { TasticProps } from '../../types';

const ContactUsTastic = ({}: TasticProps) => {
  return <ContactUs />;
};
export default ContactUsTastic;
